import React, { Component } from 'react'
import { inject, PropTypes as MobxPropTypes } from 'mobx-react'
import PropTypes from 'prop-types'

@inject('modals')
class Modal extends Component {
  handleOnclickModal = (event) => {
    event.preventDefault()

    document.body.classList.toggle('js-modal-opened')
    document.body.scrollIntoView()

    const {modals} = this.props
    modals.setModal('')
  }

  render () {
    const classModalHeader = 'b-modal-header ' + this.props.classModalHeader

    return (
      <div className='b-modal-wrap'>
        <div className='b-modal'>
          <div className={classModalHeader}>
            {this.props.title}
            <button className='b-button-close'
                    onClick={this.handleOnclickModal}
            />
          </div>
          <div className='b-modal-content'>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

Modal.wrappedComponent.contextTypes = {
  router: PropTypes.object
}

Modal.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  classModalHeader: PropTypes.string,
  modals: MobxPropTypes.observableObject
}

export default Modal



// WEBPACK FOOTER //
// ./src/containers/Modal.js